<template>
  <div class="add-btn-box" @click.prevent>
    <div class="add-card-div" v-if="has_variant || computed_price.buy_able">
      <button
        class="add-card-btn transition-main"
        :class="{
          active: select_active && has_variant,
          hover_active: has_variant,
        }"
        @click="toggle"
      >
        <span class="text-uppercase add">{{ btnText || $t("detail.add_to_cart") }}</span>
        <span class="text-uppercase select">
          <span>{{ $t("venue.productList.selected_options") }}</span>
          <span class="plus"></span>
        </span>
      </button>
    </div>
    <div class="sold-btn" v-else>
      <button class="soldout cursor-default">
        <span class="text-uppercase add"> {{ $t("detail.sold_out") }}</span>
      </button>
    </div>
    <div class="add-select-div" ref="addSelectDiv" v-if="has_variant">
      <div class="select-div-box">
        <div
          v-for="(item, index) in product_res.variant_attrs"
          :key="item.name + index"
          :style="{
            width: is_special_attr(item.special_native_name)
              ? ` calc(${
                  100 / $store.state.special_attr_num
                }% - 10px) !important`
              : '',
          }"
        >
          <v-selectStyle
            :attrs="item"
            :index="index"
            :variant_attrs="variant_attrs"
            :theme="theme"
            :show_dropdown="true"
          ></v-selectStyle>
        </div>

        <div class="add-btn">
          <button
            class="add-card-btn transition-main"
            v-if="computed_price.buy_able"
            @click="$emit('clickAdd')"
          >
            <span class="text-uppercase add">
              {{ btnText || $t("detail.add_to_cart") }}
            </span>
          </button>
          <button v-else class="soldout cursor-default">
            <span class="text-uppercase add"> {{ $t("detail.sold_out") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelectStyle from "../../../views/venue/js/view/product/selectStyle.vue";
export default {
  props: ["theme", "product_res", "variant_attrs", "computed_price", "btnText"],
  data() {
    return {
      select_active: false,
    };
  },
  methods: {
    is_special_attr(name) {
      let { special_attr_key } = this.$store.state;
      if (!name || !special_attr_key) return false;
      else if (name.toLowerCase() == special_attr_key) return true;
    },
    toggle() {
      //若无变种 直接加购
      if (!this.has_variant) {
        this.$emit("clickAdd");
        return;
      }
      //若为移动端 弹出窗口
      if (this.showMobileAddCartPopup&&this.$store.state.theme_name == "athena" && window.innerWidth < 768) {
        this.$emit("showMobileAddCartPopup");
        this.select_active = false;
        return;
      }
      this.select_active = !this.select_active;
      this.$(this.$refs.addSelectDiv).animate({ height: "toggle" }, 300);
    },
  },
  computed: {
    has_variant() {
      let { variant_attrs } = this.product_res;
      if (variant_attrs && variant_attrs.length) return true;
    },
  },
  components: {
    vSelectStyle,
  },
};
</script>
<style scoped lang='scss'>
.add-btn-box {
  margin-top: 30px;
  .add-card-div {
    .add-card-btn {
      text-align: center;
      width: 100%;
      min-height: 62px;
      font-size: 16px;
      padding: 10px;
      outline: none;
      line-height: 1.2;
      & > span {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .select {
        display: none;
        .plus {
          position: absolute;
          right: 0;
          top: 18px;
          &::after,
          &::before {
            content: "";
            position: absolute;
            right: 18px;
            height: 16px;
            top: 3px;
            border-left: 2px solid #000;
            transition: transform 250ms ease 0s;
          }
          &::after {
            transform: rotate(90deg);
          }
          &::before {
            transform: rotate(0deg);
          }
        }
      }
      .add {
        justify-content: center;
      }
      &.hover_active:hover,
      &.active {
        .add {
          display: none;
        }
        .select {
          display: flex;
        }
      }
      &.active {
        .select {
          .plus {
            &::before {
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
  .add-select-div {
    display: none;
    margin-top: 12px;
    .select-div-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      & > div {
        width: 100%;
      }
      .add-btn {
        button {
          text-align: center;
          width: 100%;
          font-size: 16px;
          min-height: 62px;
          padding: 10px;
          outline: none;
          line-height: 1.2;
        }
      }
    }
  }
  .sold-btn {
    button {
      text-align: center;
      width: 100%;
      font-size: 16px;
      min-height: 62px;
      padding: 10px;
      outline: none;
      line-height: 1.2;
    }
  }
}
@media screen and (max-width: 767px) {
  .add-btn-box {
    margin-top: 9px;
    .add-card-div {
      .add-card-btn {
        line-height: 34px;
        min-height: unset;
        padding: 0 10px;
        & > span {
          font-size: 12px;
        }
        .select {
          .plus {
            top: 5px;
          }
        }
      }
    }
    .add-select-div {
      .select-div-box {
        &::v-deep {
          .select-style-box {
            .default-select {
              select {
                height: 34px;
                padding: 6px;
                font-size: 12px;
              }
            }
          }
        }
      }
      .add-btn {
        & > button {
          height: 32px !important;
          line-height: 32px !important;
          font-size: 12px !important;
        }
      }
    }
    .sold-btn {
      button {
        line-height: 34px;
        min-height: unset;
        padding: 0 10px;
      }
    }
  }
}
</style>